module.exports = __webpack_public_path__ + "static/media/logo.8094ba1a.jpg";